import axiosClient from "./axiosClient";
import https from "https";

import ConstData from "../ConstData";

let options = {};

if (ConstData.IS_LOCAL_VERSION) {
    options = {
        httpsAgent: new https.Agent({
            rejectUnauthorized: false, // 허가되지 않은 인증을 reject하지 않겠다!
        })
    }
}

export const display = ({ userSeq }) => {
    console.log("api display:) userSeq[", userSeq, "]");

    return axiosClient.get(`/friend/${userSeq}`, options);
}

export const search = ({ kind, userSeq, userKind, keyWord }) => {
    console.log("api search:) kind[", kind, "], userSeq[", userSeq, "], userKind[", userKind, "], keyWord[", keyWord, "]");

    return axiosClient.get(`/user?kind=${kind}&userSEQ=${userSeq}&userKind=${userKind}&keyword=${keyWord}`, options);
}

export const search_id = ({ kind, userSeq, userKind, userId }) => {
    console.log("api search id:) kind[", kind, "], userSeq[", userSeq, "], userKind[", userKind, "], userId[", userId, "]");

    return axiosClient.get(`/user?kind=${kind}&userSEQ=${userSeq}&userKind=${userKind}&userID=${userId}`, options);
}

export const search_contacts = ({ kind, userSeq, userKind, userPNArray }) => {
    console.log("api search contacts:) kind[", kind, "], userSeq[", userSeq, "], userKind[", userKind, "], userPNArray => ", userPNArray);

    return axiosClient.get(`/user?kind=${kind}&userSEQ=${userSeq}&userKind=${userKind}`, options);
    /* , {
        userPNArray: userPNArray
    }); */
}

export const apply = ({ mode, userSeq, applyUserSeq }) => {
    console.log("api apply:) mode[", mode, "], userSeq[", userSeq, "], applyUserSeq[", applyUserSeq, "]");

    return axiosClient.post(`/friend/${userSeq}/${applyUserSeq}?mode=${mode}`, {
        status: ConstData.FRIEND_APPLY_STATUS.APPLY
    }, options);
}

export const apply_multi = ({ mode, userSeq, friendUserSEQList }) => {
    console.log("api apply multi:) mode[", mode, "], userSeq[", userSeq, "], friendUserSEQList => ", friendUserSEQList);

    return axiosClient.post(`/friend/${userSeq}?kind=apply&mode=${mode}`, {
        friendUserSEQList: friendUserSEQList
    }, options);
}

export const invite = ({ userSeq, inviteUserPNArray }) => {
    console.log("api invite:) userSeq[", userSeq, "], inviteUserPNArray => ", inviteUserPNArray);

    return axiosClient.post(`/friend/${userSeq}?kind=invite`, {
        friendPNList: inviteUserPNArray
    }, options);
}

export const confirm = ({ mode, userSeq, confirmUserSeq }) => {
    console.log("api confirm:) mode[", mode, "], userSeq[", userSeq, "], confirmUserSeq[", confirmUserSeq, "]");

    return axiosClient.post(`/friend/${userSeq}/${confirmUserSeq}?mode=${mode}`, {
        status: ConstData.FRIEND_APPLY_STATUS.APPROVE
    }, options);
}

export const reject = ({ mode, userSeq, rejectUserSeq }) => {
    console.log("api reject:) mode[", mode, "], userSeq[", userSeq, "], rejectUserSeq[", rejectUserSeq, "]");

    return axiosClient.put(`/friend/${userSeq}/${rejectUserSeq}?mode=${mode}`, {
        status: ConstData.FRIEND_APPLY_STATUS.REJECT
    }, options);
}

export const cancel_apply = ({ mode, userSeq, cancelUserSeq }) => {
    console.log("api cancel apply:) mode[", mode, "], userSeq[", userSeq, "], cancelUserSeq[", cancelUserSeq, "]");

    return axiosClient.put(`/friend/${userSeq}/${cancelUserSeq}?mode=${mode}`, {
        status: ConstData.FRIEND_APPLY_STATUS.CANCEL
    }, options);
}

export const remove_friend = ({ mode, userSeq, deleteUserSeq }) => {
    console.log("api remove friend:) mode[", mode, "], userSeq[", userSeq, "], deleteUserSeq[", deleteUserSeq, "]");

    return axiosClient.delete(`/friend/${userSeq}/${deleteUserSeq}?mode=${mode}`, options);
}